export default {
    company: {
        company_information: 'Company card',
        companyName: 'Name',
        companyAltName: 'Alternative name',
        address: 'Address',
        contacts: 'Contacts',
        webpage: 'Web site',
        links: 'Linked company',
        legal: 'Legal entities',
        department: 'Departments',
        labels: 'Labels',
        employees: {
            title: 'Employees',
            fullName: 'Full Name',
            position: 'Position',
            department: 'Department',
            workDate: 'Works from'
        }
    }
};
